import { $document } from '../utils/globals';

$document.on('click', 'a', function(e){
	let href = $(this).attr('href');
	let target = $(this).attr('target');

	if ( (href.indexOf(window.location.href) < 0) && (target !== "_blank") && (href !== "#") && (href !== "#footer") && (href !== "") && (! href.startsWith('mailto:')) && (! href.startsWith('tel:') && (! href.includes('#')  ) ) ) {
		e.preventDefault();

		$( "#overlay" ).show();

		$( "#overlay" ).animate({
			opacity: 1,
		}, 800, function() {
			document.location.href = href;
		});
	} else if ( href.includes('#') ) {
		e.preventDefault();

		let hash = '';
		let url = '';
		if ( href.startsWith('#') ) {
			hash = href;
		} else {
			url = new URL( href );
			hash = url.hash;
		}

		hash = hash.replace('#', '');
		
		if ( $('[data-id="' + hash + '"]').length ) {
			$('html, body').animate({
				scrollTop: $('[data-id="' + hash + '"]').offset().top
			}, 2000);
		} else if ( ! href.startsWith('#') ) {
			window.location.href = url.href;
		}
	}
});

$(window).on('load', function(){
	let hash = window.location.hash;
	hash = hash.replace('#', '');

	if ( $('[data-id="' + hash + '"]').length ) {
		$('html, body').animate({
			scrollTop: $('[data-id="' + hash + '"]').offset().top - 100
		}, 2000);
	}
});

$(window).bind("pageshow", function(event) {
	if (event.originalEvent.persisted) {
		$('body').show();
	}
});

window.onbeforeunload = function() { $( "#overlay" ).hide(); };